import {Component, Input, OnInit} from '@angular/core';
import {
  RatingEditorService,
  RatingStatus,
  GameType,
  RatingBallsRowBackEnd,
} from '../../services/rating-editor.service';

@Component({
  selector: 'app-rating-editor',
  templateUrl: './rating-editor.component.html',
  styleUrls: ['./rating-editor.component.scss']
})
export class RatingEditorComponent implements OnInit {

  @Input() isStaff;
  public edit: boolean = false;
  private _createRatingHeader = 'Добавить рейтинг игроков';
  private _editRatingHeader = 'Редактировать рейтинг игроков';
  constructor(
    private pageService: RatingEditorService
  ) { }

  ngOnInit(): void {

    this.pageService.authorized = this.isStaff === 'True';
    this.pageService.getGamesList().subscribe((response: GameType[]) => {
      this.pageService.gamesList = response;
    });
    this.pageService.getRatingsStatusesList().subscribe((response :RatingStatus[]) => {
      this.pageService.ratingStatusesList = response;
      this.pageService.statusesForCountries = response
        .filter((statusData) => statusData.need_country)
        .map(statusData => statusData.id);
      this.pageService.statusesForCity = response
        .filter((statusData) => statusData.need_city)
        .map(statusData => statusData.id);
    });

    const searchParameters = new URLSearchParams(window.location.search);
    this.edit = searchParameters.get('edit') === 'true';

    if (this.edit) {
      this.pageService.ratingIdToModify = searchParameters.get('ratingId');
      this.pageService.getRatingPointsTable().subscribe((table: RatingBallsRowBackEnd[]) => {
        if (!table?.length) {
          this.pageService.initiateDefaultRatingBallsTable();
          return;
        }
        this.pageService.ratingBallsTable = table.map((item) => {
          return {
            from: item?.place_from,
            to: item?.place_to,
            balls: item?.point_count,
            pointId: item?.point_id
          }
        })
      });
    } else {
      this.pageService.initiateDefaultRatingBallsTable();
    }

    this.pageService.brandNewRating = !this.edit;

  }

  ratingEditorPageHeader() {
    return this.edit ? this._editRatingHeader : this._createRatingHeader;
  }

}
